module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921135649_T.221c1359.jpg";